import tracking from '../../../utils/tracking';
import url from '../../../utils/url';
import { getOptimizelyCohorts, getOptimizelyEndUserId, getOptimizelySegments } from '../../optimizelyHelpers';

class Segment {
  track(data) {
    if (!imkt || !imkt.utils) {
      return;
    }

    const { action, attributes, category, label } = data;
    const { value, ...additionalAttributes } = (attributes || {});

    var eventProperties = {
      category,
      label,
      value,
      eventAction: action,
      urlParams: url.getUrlParams() || {},
      optimizelyCohorts: getOptimizelyCohorts(),
      optimizelySegments: getOptimizelySegments(),
      optimizelyEndUserId: getOptimizelyEndUserId(),
      ...additionalAttributes
    };
    tracking.trackEvent(action, eventProperties);
  }
}

export { Segment };

export default new Segment();
